// extracted by mini-css-extract-plugin
export var option = "_47-1";
export var optionActive = "_47-2";
export var pill = "_47-0";